import AbstractView = require("./abstract/AbstractView");
import 'owl.carousel';

class SoftwareView extends AbstractView {

    constructor(id: number, selector: JQuery) {
        super(id, selector);
    }

    init(): void {

        this.createCarousel();
    }

    private carouselNav: JQuery;
    private carousel: JQuery;
    private prevBtn: JQuery;
    private nextBtn: JQuery;
    private isNavControl: boolean;
    private itemId: number;
    private fixTimer: any;
    private navBtnArr: any[];

    private createCarousel(): void {


        let slideSpeed: number = 500;
        this.isNavControl = false;
        this.itemId = 0;
        this.carouselNav = this.getChildBySelector("#softwareCarouselNav");
        this.carousel = this.getChildBySelector("#softwareCarousel");

        // Carousel Nav
        this.navBtnArr = [];
        let navTotal: number = this.carouselNav.find(".carousel-item").length;
        for (let i: number = 0; i < navTotal; i++) {
            let item: JQuery = this.carouselNav.find(".carousel-item:eq(" + i + ")");
            item.attr("data-id", i);
            this.navBtnArr.push(item);
        }
        this.carouselNav.owlCarousel({
            loop: true,
            center: true,
            autoWidth: true,
            nav: false,
            dots: false,
            smartSpeed: 200
        });

        this.carouselNav.on('click tap', '.carousel-item', (event: JQuery.Event) => {
            event.preventDefault();
            this.isNavControl = true;
            this.itemId = $(event.currentTarget).data("id");
            this.carouselNav.trigger('to.owl.carousel', this.itemId);
            this.carousel.trigger('to.owl.carousel', this.itemId);
        });
        this.carouselNav.on('drag.owl.carousel', (event: JQuery.Event) => {
            // event.preventDefault();
            this.isNavControl = true;
        });
        this.carouselNav.on('dragged.owl.carousel', (event: any) => {
            // event.preventDefault();
            /*let target: JQuery = this.carouselNav.find(".owl-item.active.center");
            let index: number = target.find(".carousel-item").data("id");*/

            this.isNavControl = false;
            let direction: string = event.relatedTarget['_drag']['direction'];
            if (direction === "left") {
                this.itemId = (this.itemId + 1 > navTotal - 1) ? 0 : this.itemId + 1;
            } else if (direction === "right") {
                this.itemId = (this.itemId - 1 < 0) ? (navTotal - 1) : this.itemId - 1;
            }
            this.carouselNav.trigger('to.owl.carousel', this.itemId);
            this.carousel.trigger('to.owl.carousel', this.itemId);
        });
        this.carouselNav.on('changed.owl.carousel', (event: JQuery.Event) => {
            this.carouselNav.trigger('to.owl.carousel', this.itemId);
        });

        // CarouselContent
        let contentTotal: number = this.carousel.find(".carousel-item").length;
        for (let i: number = 0; i < contentTotal; i++) {
            let item: JQuery = this.carousel.find(".carousel-item:eq(" + i + ")");
            item.attr("data-id", i);
        }
        this.carousel.owlCarousel({
            items: 1,
            margin: 15,
            loop: true,
            touchDrag: true,
            mouseDrag: true,
            nav: false,
            dots: false,
            stagePadding: 8,
            smartSpeed: slideSpeed
        });
        this.carousel.on('changed.owl.carousel', (event: JQuery.Event) => {
            if (this.isNavControl == false) {
                if (this.fixTimer) {
                    window.clearTimeout(this.fixTimer);
                    this.fixTimer = null;
                }

                this.fixTimer = setTimeout(() => {
                    let target: JQuery = this.carousel.find(".owl-item.active");
                    let index: number = target.find(".carousel-item").data("id");
                    this.itemId = index;
                    this.carouselNav.trigger('to.owl.carousel', index);

                    window.clearTimeout(this.fixTimer);
                    this.fixTimer = null;

                }, 300)
            }
        });
        this.carousel.on('drag.owl.carousel', (event: JQuery.Event) => {
            this.isNavControl = false
        });

        // Prev / Next
        this.prevBtn = this.getChildBySelector(".carousel-control-prev");
        this.nextBtn = this.getChildBySelector(".carousel-control-next");
        this.prevBtn.on("click tap", (eventObject: JQueryEventObject) => {
            eventObject.preventDefault();
            this.isNavControl = false;
            this.carousel.trigger('prev.owl.carousel', [slideSpeed]);
        });
        this.nextBtn.on("click tap", eventObject => {
            eventObject.preventDefault();
            this.isNavControl = false;
            this.carousel.trigger('next.owl.carousel', [slideSpeed]);
        });

    }

}

export = SoftwareView;